export default __webpack_public_path__ + "static/media/brand.4a8c18c7.svg";